import { get, isNil } from 'lodash';

import {
    BEGIN_FETCH_LINKS,
    CLEAR_CONTACTS,
    CLEAR_ERP_ENTITIES,
    FETCH_AREAS,
    FETCH_BUILDING_TYPES,
    FETCH_BUSINESS_TYPES,
    FETCH_CAMPUS_SITES,
    FETCH_CLIENT_NODES,
    FETCH_CONTACTS,
    FETCH_CONTACT_LINKS,
    FETCH_CONVERSIONS,
    FETCH_EQUIPMENT,
    FETCH_ERP_CLIENTS,
    FETCH_ERP_CONTACTS,
    FETCH_ERP_SITES,
    FETCH_ERP_EQUIPMENT,
    FETCH_ERP_AGENT_CONFIGURATIONS,
    FETCH_ERP_SERVICE_APPOINTMENT_MAPPING,
    FETCH_ERP_SERVICE_CALL_MAPPING,
    FETCH_ERP_STATUSES,
    FETCH_ERP_TECHNICIANS,
    FETCH_EQUIPMENT_MANUFACTURERS,
    FETCH_FILTERED_AREAS,
    FETCH_FILTERED_EQUIPMENT,
    FETCH_FILTERED_SYSTEMS,
    FETCH_LINKS,
    FETCH_RAW_UNITS,
    FETCH_SENSORS,
    FETCH_SERVICE_APPOINTMENT_STATUSES,
    FETCH_SERVICE_CALL_STATUSES,
    FETCH_SYSTEMS,
    FETCH_TECHNICIAN_LIST,
    FETCH_TECHNICIAN_SENIORITY_LEVELS,
    FETCH_TECHNICIAN_SPECIALTIES,
    FETCH_FUEL_TYPES,
    FETCH_WEATHER_DATA,
    WEATHER_DATA_LOAD_BEGIN,
    WEATHER_DATA_LOAD_END,
    WEATHER_DATA_LOAD_ERROR,
    FETCH_WEATHER_STATION,
    ITEM_REORDER,
    SET_AREA,
    SET_CONTACT,
    SET_CONVERSION,
    SET_EQUIPMENT,
    SET_ERP_AGENT,
    SET_LINK,
    SET_NODE,
    SET_NODE_UPDATE,
    SET_SENSOR,
    SET_SELECTED_TECHNICIAN,
    SET_SYSTEM,
    SET_TREE,
    SET_TREE_RESET,
    SET_TREE_TYPE,
    TECHNICIAN_DATA_LOAD_BEGIN,
    TECHNICIAN_DATA_LOAD_END,
    TECHNICIAN_DATA_LOAD_ERROR,
    TOGGLE_CONTACT_LINKS_LOADING,
    TOGGLE_ERP_CLIENTS_LOADING,
    BEGIN_FETCH_CONTACT_LINKS
} from '../actions/actionTypes';

const initialState = {
    areas:                          [],
    buildingTypes:                  [],
    businessTypes:                  [],
    clientNodes:                    [],
    campusSites:                    [],
    contacts:                       [],
    conversions:                    [],
    error:                          null,
    erpClientsLoading:              false,
    equipment:                      [],
    filteredAreas:                  [],
    filteredEquipment:              [],
    filteredSystems:                [],
    fuelTypes:                      [],
    manufacturers:                  [],
    nodeUpdate:                     {},
    order:                          'asc',
    orderBy:                        'name',
    rawUnits:                       [],
    seniorityLevels:                [],
    selectedArea:                   {},
    selectedContact:                {},
    selectedConversion:             {},
    selectedEquipment:              {},
    selectedErpAgentId:             null,
    selectedErpAgentStatuses:       [],
    selectedErpServiceApptMapping:  null,
    selectedErpServiceCallMapping:  null,
    selectedLink:                   {},
    selectedNode:                   {},
    selectedSensor:                 {},
    selectedSystem:                 {},
    sensors:                        [],
    specialties:                    [],
    serviceAppointmentStatusesList: [],
    serviceCallStatusesList:        [],
    systems:                        [],
    techniciansLoading:             false,
    tree:                           [],
    treeReset:                      () => {},
    treeType:                       '',
    loading:                        false,
    weatherData:                    [],
    weatherStation:                 []
};

export default (state = initialState, action) => {
    let sensors;

    switch (action.type) {
        case BEGIN_FETCH_LINKS:
            return {
                ...state,
                linksLoading: true
            };
        case BEGIN_FETCH_CONTACT_LINKS:
            return {
                ...state,
                contactLinksLoading: true
            };
        case CLEAR_CONTACTS:
            return {
                ...state,
                contacts: []
            };
        case CLEAR_ERP_ENTITIES:
            return {
                ...state,
                erpClients:     [],
                erpSites:       [],
                erpEquipment:   [],
                erpTechnicians: []
            };
        case FETCH_AREAS:
            return {
                ...state,
                areas: [...action.payload]
            };
        case FETCH_BUILDING_TYPES:
            return {
                ...state,
                buildingTypes: [...action.payload]
            };
        case FETCH_BUSINESS_TYPES:
            return {
                ...state,
                businessTypes: [...action.payload]
            };
        case FETCH_CAMPUS_SITES:
            return {
                ...state,
                campusSites: [...action.payload]
            };
        case FETCH_CLIENT_NODES:
            return {
                ...state,
                clientNodes: [...action.payload]
            };
        case FETCH_CONTACTS:
            return {
                ...state,
                contacts: [...action.payload]
            };
        case FETCH_CONTACT_LINKS:
            return {
                ...state,
                contactLinks:        [...action.payload],
                contactLinksLoading: false
            };
        case FETCH_CONVERSIONS:
            return {
                ...state,
                conversions: [...action.payload]
            };
        case FETCH_EQUIPMENT:
            return {
                ...state,
                equipment: isNil(action.payload) ? [] : [...action.payload]
            };
        case FETCH_EQUIPMENT_MANUFACTURERS:
            return {
                ...state,
                manufacturers: [...action.payload]
            };
        case FETCH_ERP_CLIENTS:
            return {
                ...state,
                erpClients: [...action.payload]
            };
        case FETCH_ERP_CONTACTS:
            return {
                ...state,
                erpContacts: [...action.payload]
            };
        case FETCH_ERP_SITES:
            return {
                ...state,
                erpSites: [...action.payload]
            };
        case FETCH_ERP_EQUIPMENT:
            return {
                ...state,
                erpEquipment: [...action.payload]
            };
        case FETCH_ERP_AGENT_CONFIGURATIONS:
            return {
                ...state,
                erpAgents: [...action.payload]
            };
        case FETCH_ERP_SERVICE_APPOINTMENT_MAPPING:
            return {
                ...state,
                selectedErpServiceApptMapping: [...action.payload]
            };
        case FETCH_ERP_SERVICE_CALL_MAPPING:
            return {
                ...state,
                selectedErpServiceCallMapping: [...action.payload]
            };
        case FETCH_ERP_STATUSES:
            return {
                ...state,
                selectedErpAgentStatuses: [...action.payload]
            };
        case FETCH_ERP_TECHNICIANS:
            return {
                ...state,
                erpTechnicians: [...action.payload]
            };
        case FETCH_FILTERED_AREAS:
            return {
                ...state,
                filteredAreas: [...action.payload]
            };
        case FETCH_FILTERED_EQUIPMENT:
            return {
                ...state,
                filteredEquipment: [...action.payload]
            };
        case FETCH_FILTERED_SYSTEMS:
            return {
                ...state,
                filteredSystems: [...action.payload]
            };
        case FETCH_FUEL_TYPES:
            return {
                ...state,
                fuelTypes: [...action.payload]
            };
        case FETCH_LINKS:
            return {
                ...state,
                links:        [...action.payload],
                linksLoading: false
            };
        case FETCH_RAW_UNITS:
            return {
                ...state,
                rawUnits: [...action.payload]
            };
        case FETCH_SENSORS:
            sensors = isNil(action.payload) ? [] : [...action.payload];

            return {
                ...state,
                sensors
            };
        case FETCH_SERVICE_APPOINTMENT_STATUSES:
            return {
                ...state,
                serviceAppointmentStatusesList: [...action.payload]
            };
        case FETCH_SERVICE_CALL_STATUSES:
            return {
                ...state,
                serviceCallStatusesList: [...action.payload]
            };
        case FETCH_SYSTEMS:
            return {
                ...state,
                systems: [...action.payload]
            };
        case FETCH_TECHNICIAN_LIST:
            return {
                ...state,
                techniciansList: [...action.payload]
            };
        case FETCH_TECHNICIAN_SENIORITY_LEVELS:
            return {
                ...state,
                seniorityLevels: [...action.payload]
            };
        case FETCH_TECHNICIAN_SPECIALTIES:
            return {
                ...state,
                specialties: [...action.payload]
            };
        case FETCH_WEATHER_DATA:
            return {
                ...state,
                weatherData: [...action.payload]
            };
        case WEATHER_DATA_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case WEATHER_DATA_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case WEATHER_DATA_LOAD_ERROR:
            return {
                ...state,
                error: [...action.payload]
            };
        case FETCH_WEATHER_STATION:
            return {
                ...state,
                weatherStation: [...action.payload]
            };
        case ITEM_REORDER:
            return {
                ...state,
                ...action.payload
            };
        case SET_AREA:
            return {
                ...state,
                selectedArea: {...action.payload}
            };
        case SET_CONTACT:
            return {
                ...state,
                selectedContact: {...action.payload}
            };
        case SET_CONVERSION:
            return {
                ...state,
                selectedConversion: {...action.payload}
            };
        case SET_EQUIPMENT:
            return {
                ...state,
                selectedEquipment: {...action.payload}
            };
        case SET_ERP_AGENT:
            return {
                ...state,
                selectedErpAgentId: get(action, 'payload.id', null)
            };
        case SET_LINK:
            return {
                ...state,
                selectedLink: {...action.payload}
            };
        case SET_NODE:
            return {
                ...state,
                selectedNode: {...action.payload}
            };
        case SET_NODE_UPDATE:
            return {
                ...state,
                nodeUpdate: {...action.payload}
            };
        case SET_SELECTED_TECHNICIAN:
            return {
                ...state,
                selectedTechnician: action.selectedTechnician
            };
        case SET_SENSOR:
            return {
                ...state,
                selectedSensor: {...action.payload}
            };
        case SET_SYSTEM:
            return {
                ...state,
                selectedSystem: {...action.payload}
            };
        case SET_TREE:
            return {
                ...state,
                tree: [...action.payload]
            };
        case SET_TREE_RESET:
            return {
                ...state,
                treeReset: action.payload
            };
        case SET_TREE_TYPE:
            return {
                ...state,
                treeType: action.payload
            };
        case TECHNICIAN_DATA_LOAD_BEGIN:
            return {
                ...state,
                techniciansLoading: true
            };
        case TECHNICIAN_DATA_LOAD_END:
            return {
                ...state,
                techniciansLoading: false
            };
        case TECHNICIAN_DATA_LOAD_ERROR:
            return {
                ...state,
                error: [ ...action.payload ]
            };
        case TOGGLE_CONTACT_LINKS_LOADING:
            return {
                ...state,
                contactLinksLoading: action.payload
            };
        case TOGGLE_ERP_CLIENTS_LOADING:
            return {
                ...state,
                erpClientsLoading: action.payload
            };
        default:
            return state;
    }
};
